<script lang="ts">
  import { ArtworkLink } from '@shared/ui/links/artwork-link';
  import { is } from '@shared/utils';

  type TechParam = {
    name: string;
    value?: string | null;
    url?: string;
  };

  export let items: TechParam[];
  export let variant: 'primary' | 'secondary' = 'primary';
  export let size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'lg';
  const sizesClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
  };
</script>

<ul class="w-full">
  {#each items as item}
    {#if item.name && item.value}
      <li class="mb-2 w-full">
        <ul class="grid grid-cols-2 {sizesClasses[size]}">
          <li class="text-default-700 dark:text-default-500">{item.name}</li>

          <li class="{is(variant === 'primary', 'font-medium')}">
            {#if item.url}
              <ArtworkLink href="/{item.url}" target="_blank">
                {item.value}
              </ArtworkLink>
            {:else}
              {item.value}
            {/if}
          </li>
        </ul>
      </li>
    {/if}
  {/each}
</ul>
